<esa-material-button type="clear" icon="restart_alt" tooltip="Reset Filter" (click)="clearFilters()" [disabled]="!isFilterActive()"> </esa-material-button>
